export function groupBy<T>(list: T[], keyGetter: (e: T) => string): { group: string; order: number; items: T[] }[] {
  const map = new Map<string, T[]>();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return Array.from(map, ([key, value]) => {
    return { group: key, items: value, order: 0 };
  });
}
